import { render } from "./navbar-search.vue?vue&type=template&id=5d8a5b35&scoped=true&lang=pug"
import script from "./navbar-search.vue?vue&type=script&lang=js"
export * from "./navbar-search.vue?vue&type=script&lang=js"

import "./navbar-search.vue?vue&type=style&index=0&id=5d8a5b35&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d8a5b35"]])

export default __exports__